<template>
  <div>
  <div class="content content-boxed">
    <div class="col-sm-12 push-50">
    </div>
    <div class="col-sm-12 push-50">
    </div>
    <div class="col-sm-12 push-50">
    </div>

    <div v-if = "profileData.sharingInvitations.length==0">
      <h4>{{messageNoMoreSharing[actualLanguage]}}</h4>
          <div class="col-sm-12 push-50">
    </div>
      <h3>{{messageNoMoreSharing2[actualLanguage]}}</h3>
    </div>

    <div v-else>
      <div v-if = "defaultGroupSelectedFlag">
        
        <div v-if = "displayListSharingFlag">
          <div v-for="(invitation,index) in profileData.sharingInvitations">
            <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Channel'" class="col-sm-12">
              <sharing-item :index="index"></sharing-item>
            </div>
          </div>
        </div>

        <div v-if = "displayListSharingFlag">
          <div v-for="(invitation,index) in profileData.sharingInvitations">
            <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Car'" class="col-sm-12">
              <sharing-item :index="index"></sharing-item>
            </div>
          </div>
        </div>

        <div v-if = "displayListSharingFlag">
          <div v-for="(invitation,index) in profileData.sharingInvitations">
            <div v-if="invitation.InvitationStatus=='Pending' & invitation.SharedEntityType=='Device'" class="col-sm-12">
              <sharing-item :index="index"></sharing-item>
            </div>
          </div>
        </div>

      </div>
      <div v-else>
        <div v-if = "displayListSharingFlag">
          <div v-for="(invitation,index) in profileData.sharingInvitations">
            <div v-if="invitation.InvitationStatus=='Pending'" class="col-sm-12">
              <sharing-item :index="index"></sharing-item>
            </div>
          </div>
        </div>
      </div>

    </div>                       

  </div>
</div>

</template>


<script>

import Spinner from '@/components/Spinner'
import _ from 'underscore'
import {mapState, mapActions, mapGetters} from 'vuex'
import SharingItem from './SharingItem'

export default {
  name: 'GroupIndex',

  data() {
    return {
      isOpen : true,

      loadingData : false,
      defaultGroupSelectedFlag : false,
      displayListSharingFlag : false,

      messageNoMoreSharing: {FR: "Plus de partage en attente pour l'instant. Vous devez selectionner un autre menu.", EN: 'No more sharings for now. Select other menu.'},
      messageNoMoreSharing2: {FR: "Appuyez sur le bouton Actualiser et sélectionnez l'un des menus Mesures ou Configuration.", EN: 'Press Refress button and select Measurement or Configuration menu.'},
      
      actualLanguage : "FR",

    }
  },
  components: {
    Spinner,
    SharingItem,

  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualGroup','actualBundle']),
    ...mapState('devicesStore',['devices', 'devicesPortData']),
  },

  watch: {
    profileData() {
      this.displayListSharingFlag = false
      this.$nextTick(() => {
          this.displayListSharingFlag = true
        });
      
    }
  },

  methods: {
    ...mapActions('overlayStore', ['showModal']),

    reloadPage(){
      window.location.reload()
    },


    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()

    window.scrollTo(0, 0)
    this.defaultGroupSelectedFlag =  this.actualGroup.group_id.includes(':DefaultGroup')
    this.displayListSharingFlag = true

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>




// WEBPACK FOOTER //
// Index.vue?05f26a0a